const esLocale = {
	cancel: 'Cancelar',
	collapseAll: 'Contraer todo',
	expandAll: 'Expandir todo',
	takingLongTime: 'Se está tomando demasiado tiempo...',
	summary: 'Resumen',
	date: 'Fecha',
	today: 'Hoy',
	yesterday: 'Ayer',
	last7Days: 'Últimos 7 días',
	last30Days: 'Últimos 30 días',
	thisMonth: 'Este mes',
	lastMonth: 'El mes pasado',
	startDate: 'Fecha inicial',
	endDate: 'Fecha final',
	requiredField: 'Este campo es obligatorio',
	'newShiftModal.timeField': 'Esta no es una hora válida',
	shiftNotification:
		'Los turnos que comienzan antes del inicio del día serán registrados en el día anterior. La hora de inicio es {time}.',
	order: 'Pedido',
	print: 'Imprimir',
	'welcomeNewCpModal.title': 'Lavu 4',
	'welcomeNewCpModal.subtitle':
		'Gracias por usar el nuevo Panel de Control de Lavu.',
	'welcomeNewCpModal.getStarted': 'Iniciar',
	alphaNumericSpacesFieldMsg:
		'Este campo sólo puede incluir caracteres alfanuméricos o espacios',
	invalidNumberMsg: 'Este no es un número válido',
	numericFieldMsg: 'Este campo solo puede incluir números',
	numericFieldMaxMsg: 'Este campo debe ser inferior a {val}',
	numericFieldMinMsg: 'Este campo debe ser mayor a {val}',
	requiredFieldMsg: 'Este campo es obligatorio',
	emailFieldMsg: 'Este campo debe ser un email válido',
	integerFieldMsg: 'Este campo solo puede incluir números enteros',
	maxLengthFieldMsg: 'Este campo no puede tener mas de {max} caracteres',
	unauthorizedModuleMsg: 'Aún no se le ha otorgado acceso a ningún módulo',
	save: 'Guardar',
	fieldAdd: 'Agregar',
	fieldSave: 'Guardar',
	fieldCancel: 'Cancelar',
	contactUs: 'Contáctanos',
	myAccount: 'Mi cuenta',
	trialEnded: 'El período de prueba ha terminado',
	trialEndedLavuAdmin: 'El período de prueba ha terminado.',
	trialEndedContactUs: 'Por favor contáctanos para continuar usando Lavu.',
	trialLastDay: 'Hoy es el último día de prueba.',
	trialEndsInDays:
		'El período de prueba termina en {val} {val, plural, one {día} other {días}}.',
	billingToResolveInDays:
		'Tu cuenta tiene un saldo pendiente, tienes {val} {val, plural, one {día} other {días}} para resolver este problema.',
	billingToResolveToday:
		'Tu cuenta tiene un saldo pendiente, hoy es el último día para resolver este problema.',
	billingGraceEnded: 'Tu cuenta ha sido bloqueada por problemas de cobro.',
	billingGraceEndedAdmin: 'Tu cuenta tiene un saldo pendiente.',
	notAvailableRecord: 'N/A',
	paginatorOf: 'de',
	allRightsReserved: 'Todos los derechos reservados',
	somethingWentWrong: '¡Lo sentimos! Algo salió mal.',
	attention: 'Atención',
	stayLoggedIn: 'Permanecer conectado',
	terminatingSession:
		'Debido a la inactividad, su sesión está siendo terminada',
	inactiveSessionMinutes: `Debido a la inactividad, su sesión será terminada en {minutes} {timeLeft, plural,
		one {minuto}
		other {minutos}
	}`,
	inactiveSessionSeconds: `Debido a la inactividad, su sesión será terminada en {minutes} {timeLeft, plural,
		one {segundo}
		other {segundos}
	}`,
	inactivityLoggedOut: `Debido a la inactividad, su sesión fue terminada`,
	loading: 'Cargando...',
	yes: 'Sí',
	no: 'No',
};

export default esLocale;
